function languageData() {
  return {
    instructions: "Instruções",
    language: "Idioma",
    nav: {
      p0: "Serviços",
      p1: "A Equipa",
      p2: "Blog",
      p3: "Contactos",
      p4: "Ferramentas",
      p5: "MARCAR REUNIÃO",
    },
    greeting: "Bem-vindo(a)! Favor inserir o código de acesso",
    enter: "Inserir código de acesso",
    get: "Não tenho um código",
    mail: "Cadastrar-se e receber código",
    back: "Voltar",
    again: "Tentar cadastro novamente",
    incorrect: "O código está incorreto, favor tentar novamente",
    subscribe:
      "Cadastre-se em minha newsletter para receber o código de acesso e receber os mais novos insights de marketing (pode ser desfeito a qualquer momento)",
    mailsent:
      "Cadastro realizado com sucesso! Favor verificar seu e-mail e inserir o código recebido",
    placeholder1: "Favor inserir o código",
    placeholder2: "Favor inserir seu email",
    wrongCode: "O código inserido está incorreto",
    wrongEmail: "O email inserido é inválido.",
    privacyAgree: "Ao marcar esta caixa, você concordo com nossa",
    privacyAgree2: "política de privacidade",
    notAgreed:
      "Favor concordar com a política de privacidade para se cadastrar",
    notSupported:
      "Parece que seu navegador não suporta algumas das funcionalidades usadas aqui e elas podem não funcionar corretamente. Para uma melhor experiência, recomenda-se atualizar seu navegador.",
    close: "fechar",
    facebookAdsCalculator: {
      title: "Calculadora de Budget para Facebook Ads",
      typeplaceholder: "Digite aqui",
      disclaimer: {
        p0:
          "Permite pelo menos 1x AOV para começares a fazer otimizações na tua conta de anúncios.",
        p1:
          "Nesta calculadora o budget é alterado também pela frequência de análise e otimização. Quanto mais se gastar, mais rápido se consegue ter dados para otimizar. Quanto menos se gastar, menos rápido se consegue otimizar.",
        p2:
          "Outro fator importante (que não considero nesta calculadora por ser mais específico) é o tamanho da audiência.",
        p3:
          "Usar demasiado budget numa certa audiência pode significar maior frequência e aumento de custos a longo prazo dado à saturação.",
      },
      warning: "Alerta: A soma das percentagens abaixo é de ",
      col1: {
        p1: "Pressupostos",
        p2: "em",
        p3: "Frequência de Análise",
        p4: "Ticket Médio / AOV",
      },
      col2: { p1: "Diário", p2: "Mensal" },
      tooltips: {
        p0: "Altera os números a verde para obter o budget",
        p1:
          'TOF - Top-of-funnel (Topo do funil), é a parte de cima do funil de conversão/marketing, nesta secção do funil queremos mostrar anúncios a pessoas que nunca ouviram falar de nós e nunca viu um anúncio nosso. A esta audiência costumamos chamar "Cold Audience".',
        p2:
          'MOF - Middle-of-funnel (Meio do Funil) é a parte central do funil de conversão/marketing, nesta secção do funil queremos mostrar anúncios a pessoas que já viram um anúncio nosso e interagiram com ele. Estas pessoas já mostraram algum interesse pelo nosso produto ou serviço mais ainda não decidiram avançar com a compra. A esta audiência costumamos chamar "Warm Audience".',
        p3:
          'BOF - Bottom-of-funnel (Fundo do Funil) é a parte de baixo do funil de conversão/marketing, nesta secção do funil queremos mostrar anúncios a pessoas que já viram um anúncio nosso, entraram no nosso site e realizaram alguma interação valiosa como ver uma página de produto, adicionar um produto ao carrinho ou até iniciar o checkout mas ainda não converteram. A esta audiência costumamos chamar "Hot Audience".',
        p4:
          "AOV - Average Order Value, é o valor médio das tuas vendas na loja online, consegues chegar a este valor dividindo o total da faturação pelo número de vendas num certo período de tempo.",
        p5: "Exemplos de frequência:",
        p6: "1 - Dia a dia",
        p7: "2 - De 2 em 2 dias",
        p8: "3 - De 3 em 3 dias",
        p9: "X - De X em X dias",
      },
    },
  };
}

export default languageData;
